import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import * as moment from 'moment';
@Component({
  selector: 'app-paginated-list',
  templateUrl: './paginated-list.component.html',
  styleUrls: ['./paginated-list.component.css']
})
export class PaginatedListComponent implements OnInit {
  @Input() currentPage:any = 1;
  @Input() customFilter:any;
  @Input() classData:any;
  @Input() classWeeklyData: any;
  @Input() isApiOnProgress: boolean = true;
  @Input() isFirstApiOnProgress: boolean = false;
  @Output() actionOnPageChange= new EventEmitter<any>();

  public page: any = 1;

  constructor() { }

  ngOnInit(): void {
  console.log(this.classData, this.classWeeklyData);

  }

  setWeek(i: any, data:any){
    this.customFilter['week'] = i;
    this.customFilter['s'] = data.s;
    this.customFilter['e'] = data.e;
  }

  pageChanged(event: PageChangedEvent): void {
    this.currentPage = event.page;
    this.page = event.page;
    this.customFilter.filters.page = this.page;
    this.actionOnPageChange.emit({page: this.page});
    // if(this.currentPage != event.page) {
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const _propName in changes) {
      if (changes.hasOwnProperty(_propName)) {
        switch (_propName) {
          case "currentPage":
            console.log("ngOnChanges: ", this.currentPage);
            // if (changes.videoLink.currentValue) {
            //   setTimeout(() => {
            //     this.initVideoTagEvent();
            //   }, 5000);
            // } else {
            //   this.vInstance = null;
            // }
            break;
        }
      }
    }
  }


}
